import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Globals } from '../../globals';
import { Observable, throwError } from 'rxjs';

@Injectable()
export class CoachService {

    url: string = `${this._Globals.serviceUrl}CoachService.svc/`;
    
    constructor(
        private httpClient: HttpClient,
        private _Globals: Globals) { }

    public getCoachAssignedAssessments(): Observable<any> {
        let url = `${this.url}GetCoachAssignedAssessments?coachId=${this._Globals.getUserId()}`;

        return this.httpClient.get(url);
    }

    public getCoachAssignedAssessmentsByType(assessmentType: number): Observable<any> {
        let userId = (this._Globals.assignedUserId == undefined) ? this._Globals.getUserId() : this._Globals.assignedUserId;
        let url = `${this.url}GetCoachAssignedAssessmentsByType?assessmentType=${assessmentType}&coachId=${userId}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public getCoachAssignedAssessmentsByTypeByTag(assessmentType: number, tags: string[]): Observable<any> {
        let url = `${this.url}GetCoachAssignedAssessmentsByTypeByTag?assessmentType=${assessmentType}&coachId=${this._Globals.getUserId()}&tags=${tags}`;
        console.log(url);

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public getCoachAvailableAssessmentsByType(assessmentType: number): Observable<any> {
        let url = `${this.url}GetCoachAvailableAssessmentsByType?assessmentType=${assessmentType}&coachId=${this._Globals.getUserId()}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public getCoachAvailableAssessments(coachId: number): Observable<any> {
        let url = `${this.url}GetCoachAvailableAssessments?coachId=${coachId}`;

        return this.httpClient.get(url);
    }

    public getCoachCompletedAssessments(): Observable<any> {
        let url = `${this.url}GetCoachCompletedAssessments?coachId=${this._Globals.getUserId()}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public getCoachCompletedAssessmentsByType(assessmentType: number): Observable<any> {
        let userId = (this._Globals.completedUserId == undefined) ? this._Globals.getUserId() : this._Globals.completedUserId;
        let url = `${this.url}GetCoachCompletedAssessmentsByType?assessmentType=${assessmentType}&coachId=${userId}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public getCoachCompletedAssessmentsByTypeByTag(assessmentType: number, tags: string[]): Observable<any> {
        let url = `${this.url}GetCoachCompletedAssessmentsByTypeByTag?assessmentType=${assessmentType}&coachId=${this._Globals.getUserId()}&tags=${tags}`;

        console.log(url);

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public getCoachDashboardInfo(): Observable<any> {
        let url = `${this.url}GetCoachDashboardInfo?coachId=${this._Globals.getUserId()}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public getCoachExpiredAssessmentsByType(assessmentType: number): Observable<any> {
        let userId = (this._Globals.expiredUserId == undefined) ? this._Globals.getUserId() : this._Globals.expiredUserId;
        let url = `${this.url}GetCoachExpiredAssessmentsByType?assessmentType=${assessmentType}&coachId=${userId}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public getCoachExpiredAssessmentsByTypeByTag(assessmentType: number, tags: string[]): Observable<any> {

        let url = `${this.url}GetCoachExpiredAssessmentsByTypeByTag?assessmentType=${assessmentType}&coachId=${this._Globals.getUserId()}&tags=${tags}`;
        console.log(url);

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public getCoachProfile(userId: number): Observable<any> {
        let url = `${this.url}GetCoachProfile?coachId=${userId}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public getCoachTags(): Observable<any> {
        let url = `${this.url}GetCoachTags?coachId=${this._Globals.getUserId()}`;
        console.log('getCoachTags', url);

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public getCoachTotalAvailableAssessments(status: boolean): Observable<any> {
        let url = `${this.url}GetCoachTotalAvailableAssessments?coachId=${this._Globals.getUserId()}&is360=${status}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public getCoachTotalAssignedAssessments(status: boolean): Observable<any> {
        let url = `${this.url}GetCoachTotalAssignedAssessments?coachId=${this._Globals.getUserId()}&is360=${status}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public getCoachTotalCompletedAssessments(status: boolean): Observable<any> {
        let url = `${this.url}GetCoachTotalCompletedAssessments?coachId=${this._Globals.getUserId()}&is360=${status}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public getRaterTypesByCoach(): Observable<any> {
        let url = `${this.url}GetRaterTypesByCoach?coachId=${this._Globals.getUserId()}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public getRaterTypesForCoach(): Observable<any> {
        let url = `${this.url}GetRaterTypesForCoach?coachId=${this._Globals.getUserId()}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    //{"clientIds":[ARRAY OF CLIENT IDS],"coachId":[COACH ID]}
    public postDeleteClients(clientIds: number[]): Observable<any> {

        let url = `${this.url}DeleteClients`;

        let body: any = {
            "clientIds": clientIds,
            "coachId": this._Globals.getUserId()
        }

        body = JSON.stringify(body);
        console.log('DeleteClients body: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    //{"assignmentIds":[[ASSIGNMENT IDS]], "expiresOn":[EXPIRATION DATE]}
    public postUpdateAssignment(assignmentIds: number[], expiresOn: string, sentDate: string, scheduledTime: string, timeOffset:number): Observable<any> {

        let url = `${this.url}UpdateAssignment `;

        let body: any = {
            assignmentIds: assignmentIds,
            expiresOn: expiresOn,
            scheduledFor: sentDate,
            scheduledTime: scheduledTime,
            timeOffset: timeOffset
        }
        body = JSON.stringify(body);
        console.log('body extendExpirationDate: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    //{"coachId":[COACH ID],"data":"[CSV FILE BASE64]"}
    public postImportClients(base64file: string): Observable<any> {

        let url = `${this.url}ImportClients`;

        let body: any = {
            coachId: this._Globals.getUserId(),
            data: base64file
        }
        body = JSON.stringify(body);
        console.log('body importClients: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    public postImportAndAssignClients(input: AssessmentAssignmentDto, base64file:string): Observable<any> {

        let url = `${this.url}ImportAndAssignClients`;

        let importAndAssignClients: any = {
            "coachId": this._Globals.getUserId(),
            "assignment": {
                "CoachId": input.CoachId,
                "AssessmentId": input.AssessmentId,
                "Language": input.Language,
                "ScheduledDate": input.ScheduledDate,
                "ScheduledTime": input.ScheduledTime,
                "TimeOffset": input.TimeOffset,
                "ExpiresIn": input.ExpiresIn,
                "SendNow": input.SendNow,
                "ClientIds": [],
                "UseCustomEmailTemplates": input.UseCustomEmailTemplates,
                "EmailTemplates": input.EmailTemplates,
                "Tags": input.Tags,
                "Raters": input.Raters
            },
            "data": base64file
        };

        let body = JSON.stringify(importAndAssignClients);
        console.log('body importAndAssignClients: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    //{"clientId":[CLIENT ID],"assignedBy":[COACH ID],"assignmentId":[ASSIGNMENT ID],"data":"[CSV FILE BASE64]"}
    public postImportRaters(importRatersDto: ImportRatersDto): Observable<any> {

        let url = `${this.url}ImportRaters`;

        let body: any = {
            clientId: importRatersDto.clientId,
            assignedBy: this._Globals.getUserId(),
            assignmentId: importRatersDto.assignmentId,
            data: importRatersDto.data,
            expiresIn: importRatersDto.expiresIn,
            scheduledFor: importRatersDto.scheduledFor,
            language: importRatersDto.language,
            sendEmailInvitationNow: importRatersDto.sendEmailInvitationNow,
            timeOffSet: importRatersDto.timeOffSet
        }
        body = JSON.stringify(body);
        console.log('body importRaters: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    public postSaveAssessmentAssignment(input: AssessmentAssignmentDto): Observable<any> {
          let url = `${this.url}SaveAssessmentAssignment`;
        //let url = `http://localhost:54541/CoachService.svc/SaveAssessmentAssignment`;

        let saveAssessmentAssignment: any = { 
            "assignment": {
                "CoachId": input.CoachId,
                "AssessmentId": input.AssessmentId,
                "Language": input.Language,
                "ScheduledDate": input.ScheduledDate,
                "ScheduledTime": input.ScheduledTime,
                "TimeOffset": input.TimeOffset,
                "ExpiresIn": input.ExpiresIn,
                "SendNow": input.SendNow,
                "ClientIds": input.ClientIds,
                "UseCustomEmailTemplates": input.UseCustomEmailTemplates,
                "EmailTemplates": input.EmailTemplates,
                "Tags": input.Tags,
                "Raters": input.Raters,
                "MetaData": input.MetaData
            }
        };

        let body = JSON.stringify(saveAssessmentAssignment);
        console.log('body saveAssessmentAssignment: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers }).catch(this.handleError);
    }

    private handleError(error: Response): Observable<any> {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        //console.log("ERROR",error);
        return Observable.throw(error);
    }

    //postSaveAssessmentAssignment(input: AssessmentAssignmentDto) {

    //    let url = `${this.url}SaveAssessmentAssignment`;

    //    let saveAssessmentAssignment: any = {
    //        "assignment": {
    //            "CoachId": input.CoachId,
    //            "AssessmentId": input.AssessmentId,
    //            "Language": input.Language,
    //            "ScheduledDate": input.ScheduledDate,
    //            "ScheduledTime": input.ScheduledTime,
    //            "TimeOffset": input.TimeOffset,
    //            "ExpiresIn": input.ExpiresIn,
    //            "SendNow": input.SendNow,
    //            "ClientIds": input.ClientIds,
    //            "UseCustomEmailTemplates": input.UseCustomEmailTemplates,
    //            "EmailTemplates": input.EmailTemplates,
    //            "Tags": input.Tags,
    //            "Raters": input.Raters
    //        }
    //    };

    //    let body = JSON.stringify("");
    //    console.log('body saveAssessmentAssignment: ' + body);

    //    let headers = new HttpHeaders()
    //        .set('Content-Type', 'application/json')
    //        .set('authorization', 'Bearer ' + this._Globals.getToken());

    //    return this.httpClient.post(url, body, { headers: headers });
    //}

    //{"coach":{"Id":[COACH ID],"FirstName":"[FIRST NAME]","LastName":"[LAST NAME]"}}
    public postSaveCoach(userInfo: UserInfoDto): Observable<any> {

        let url = `${this.url}SaveCoach`;

        let saveCoach: any = {
            "coach": {
                "Id": this._Globals.getUserId(),
                "FirstName": userInfo.FirstName,
                "LastName": userInfo.LastName,
                "BusinessName": userInfo.BusinessName,
                "Email": userInfo.Email,
                "Logo": userInfo.Logo,
            }

        }

        let body = JSON.stringify(saveCoach);
        console.log('body saveCoach: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    //{"coachId":[COACH ID],"email":[EMAIL],"firstName":[FIRST NAME],"lastName":[LAST NAME]}
    public postSaveCoachClient(email: string, name: string, last: string): Observable<any> {

        let url = `${this.url}SaveCoachClient`;

        let saveCoachClient: any = {
            "coachId": this._Globals.getUserId(),
            "email": email,
            "firstName": name,
            "lastName": last
        }

        let body = JSON.stringify(saveCoachClient);
        console.log('body saveCoachClient: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    public postSendAssessmentReminder(assignmentIds: number[]): Observable<any> {

         let url = `${this.url}SendAssessmentReminder`;
        //let url = `http://localhost:54541/CoachService.svc/SendAssessmentReminder`;

        let body: any = {
            assignmentIds: assignmentIds
        }
        body = JSON.stringify(body);
        console.log('body sendAssessmentReminder: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    //{"assignmentIds":[1,2,3]}
    public postUnassignAssessments(assignmentIds: number[]): Observable<any> {
        let url = `${this.url}UnassignAssessments`;

        let body: any = {
            "assignmentIds": assignmentIds
        }

        body = JSON.stringify(body);
        console.log('Post UnassignAssessments body: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    public getCoachClients(): Observable<any> { //clientId: number
        let url = `${this.url}GetCoachClients?coachId=${this._Globals.getUserId()}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });

    }

    getArchivedCoachClients() {
        let url = `${this.url}GetArchivedCoachClients?coachId=${this._Globals.getUserId()}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    //{"input":{"AssignmentIds":[1,2],"EnableResults":true}}
    public postEnableClientSeeResults(assignmentIds: number[], enableResults: boolean): Observable<any> {
        let url = `${this.url}EnableClientSeeResults`;

        let body: any = {
            input: {
                AssignmentIds: assignmentIds,
                EnableResults: enableResults
            }
        };

        body = JSON.stringify(body);
        console.log('body EnableClientSeeResults: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    //{"input":{"ClientId":"[CLIENT ID]","FirstName":"[FIRST NAME]","LastName":"[LAST NAME]"}}
    public postUpdateClient(coachClient: CoachClientDto): Observable<any> {
        let url = `${this.url}UpdateClient`;

        let body: any = {
            input: {
                ClientId: coachClient.ClientId,
                FirstName: coachClient.FirstName,
                LastName: coachClient.LastName,
                Email: coachClient.Email
            }
        };

        body = JSON.stringify(body);
        console.log('body UpdateClient: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    //{"assignmentId":[ASSIGNMENT ID], "ratersIds":[[RATER IDS]]}
    public postDeleteRaters(assignmentId: number, ratersIds: number[]): Observable<any> {
        let url = `${this.url}DeleteRaters`;

        let body: any = {
            assignmentId: assignmentId,
            ratersIds: ratersIds
        };

        body = JSON.stringify(body);
        console.log('body postDeleteRaters: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    //{ "assignmentId": [ASSIGNMENT_ID], "raterId": [RATER ID], "firstName": "  [FIRST NAME]", "lastName": "[LAST NAME]", "relationship": [RELATIONSHIP ID] }
    public postUpdateRater(rater: UpdateRaterDto): Observable<any> {
        let url = `${this.url}UpdateRater`;

        let body: any = {
            "assignmentId": rater.assignmentId,
            "raterId": rater.raterId,
            "firstName": rater.firstName,
            "lastName": rater.lastName,
            "relationship": rater.relationship
        };

        body = JSON.stringify(body);
        console.log('body postUpdateRater: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    public getCoachCreditCards(): Observable<any> {
        let url = `${this.url}GH7?or3=${this._Globals.getUserId()}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    //{"u2":[CURRENT USER ID],"i9":"[ENCRYPTED JSON FOR CREDIT CARD]"}
    public postAddNewCreditCard(encriptedJson: string): Observable<any> {
        let url = `${this.url}PE3`;

        let body: any = {
            "u2": this._Globals.getUserId(),
            "i9": encriptedJson
        };

        body = JSON.stringify(body);
        console.log('body postAddNewCreditCard: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    public postAddBillingAddress(encriptedJson: string): Observable<any> {
        let url = `${this.url}N67`;

        let body: any = {
            "v4": encriptedJson
        };

        body = JSON.stringify(body);
        console.log('body postAddNewCreditCard: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    public getAvailableAssessmentsAuthorized(coachId: number): Observable<any> {
        let url = `${this.url}CM79?hw71=${coachId}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public postUpdateCoachAvailableAssessments(encriptedJson: string): Observable<any> {
        let url = `${this.url}QY43`;

        let body: any = {
            "jx": encriptedJson
        };

        body = JSON.stringify(body);
        console.log('body postUpdateCoachAvailableAssessments: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    public postArchiveAssessments(encriptedJson: string): Observable<any> {
        let url = `${this.url}VR34`;

        let body: any = {
            "sv": encriptedJson
        };

        body = JSON.stringify(body);
        console.log('body postArchiveAssessments: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    public getCoachArchivedAssessments(assessmentType: number): Observable<any> {
        let url = `${this.url}LN56?mr5=${this._Globals.getUserId()}&lr2=${assessmentType}`;

        return this.httpClient.get(url);
    }

    public postAddAssessmentsTags(assignmentsIds: number[], tags: string[]): Observable<any> {
        const url = `${this.url}F4RT`;

        let body: any = {
            'jw2': this._Globals.getUserId(),
            'nr5': assignmentsIds,
            'uy3': tags
        };

        body = JSON.stringify(body);
        console.log('body postAddAssessmentsTags: ' + body);

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    postUpdateSendReminderEmail(assignmentId: string, enable: boolean) {
        let url = `${this.url}UpdateReminderEmailForAssignmentId`;

        let body: any = {
            "assignmentId": assignmentId,
            "enable": enable
        }

        body = JSON.stringify(body);
        console.log('UpdateReminderEmailForAssessment body: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    GetReminderEmailStatusForAssignmentId(assignmentId: number) {
        let url = `${this.url}GetReminderEmailStatusForAssignmentId?assignmentId=${assignmentId}`;

        return this.httpClient.get(url);
    }

    postSendReminderEmailToRaters(assignmentId: number) {
        const url = `${this.url}SendReminderEmail`;

        let body: any = {
            "assignmentId": assignmentId
        }

        body = JSON.stringify(body);
        console.log('SendReminderEmailToRaters body: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    postArchiveCoachClients(clientIds: Array<number>) {
        const url = `${this.url}ArchiveClients`;

        let body: any = {
            clientIds,
            coachId: this._Globals.getUserId()
        };

        body = JSON.stringify(body);
        console.log('ArchiveClients body: ' + body);

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    postActivateCoachClients(clientIds: Array<number>) {
        const url = `${this.url}ActivateClients`;

        let body: any = {
            clientIds,
            coachId: this._Globals.getUserId()
        };

        body = JSON.stringify(body);
        console.log('ActiveClients body: ' + body);

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });
        return this.httpClient.post(url, body, { headers });
    }


    getTagsByAssignmentId(assignmentId: string) {
        let url = `${this.url}GetTagsByAssignmentId?assignmentId=${assignmentId}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers });
    }

    postRemoveTag(assignmentId: string, tagText: string) {
         const url = `${this.url}RemoveTag`;

        let body: any = {
            assignmentId,
            tagText
        };

        body = JSON.stringify(body);
        console.log('body postRemoveTag: ' + body);

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });
        return this.httpClient.post(url, body, { headers });
    }

    getCoachArchivedAssessmentsByTypeByTag(assessmentType: number, tags: string[]) {
        let url = `${this.url}GetCoachArchivedAssessmentsByTypeByTag?coachId=${this._Globals.getUserId()}&assessmentType=${assessmentType}&tags=${tags}`;
        console.log(url);
        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    GetCoachClientByTag(tags: string[]) {
        let url = `${this.url}GetCoachClientByTag?coachId=${this._Globals.getUserId()}&tags=${tags}`;
        
        console.log(url);
        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    getClientTags(clientId: number) {
         let url = `${this.url}GetClientTags?clientId=${clientId}`;

         let headers = new HttpHeaders()
             .set('Content-Type', 'application/json')
             .set('authorization', 'Bearer ' + this._Globals.getToken());
 
         return this.httpClient.get(url, { headers });
    }

    postRemoveClientTag(clientId: number, tagText: string) {
         const url = `${this.url}RemoveClientTag`;

        let body: any = {
            clientId,
            tagText
        };

        body = JSON.stringify(body);
        console.log('body postRemoveClientTag: ' + body);

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });
        return this.httpClient.post(url, body, { headers });
    }

    postSaveClientTags(clientIds: Array<number>, tagTexts: Array<string>) {
         const url = `${this.url}SaveClientTag`;

        let body: any = {
            coachId: this._Globals.getUserId(),
            clientIds,
            tagTexts
        };

        body = JSON.stringify(body);
        console.log('body postSaveClientTags: ' + body);

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });
        return this.httpClient.post(url, body, { headers });
    }

    getGroupAveragesForArlAndPerceptionCharts(assignmentIds: Array<string>): Observable<{result: {Result: number, Data: string}}> {
         const url = `${this.url}GetGroupAveragesForArlAndPerceptionCharts`;
        //const url = `http://localhost:54541/CoachService.svc/GetGroupAveragesForArlAndPerceptionCharts`;

        const body = {
            assignmentIds
        };

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.post<{result: {Result: number, Data: string}}>(url, body,{ headers });
    }

    getCategoriesByAssignment(assignmentId: string) {
        let url = `${this.url}GetCategoriesByAssignment?assignmentId=${assignmentId}`;
        return this.httpClient.get(url);
    }

    getRaterCompleteAssignmentByType(assignmentId: string, raterType: number) {
        let url = `${this.url}GetRaterCompleteAssignmentByType?assignmentId=${assignmentId}&raterType=${raterType}`;

        return this.httpClient.get(url);
    }

    postRemoveCategory(newRaterType: number, raterType: number, assignmentId: string) {
        const url = `${this.url}RemoveCategory`;

        let body: any = {
            newRaterType,
            raterType,
            assignmentId
        };

        body = JSON.stringify(body);
        console.log('body postRemoveCategory: ' + body);

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    ssoELIShopy() {
        const url = `https://community.ipeccoaching.com/sso-eli-shopify/`;

        let body: any = {
            "contact_id": "2822308",
            "user_email": "johanngranados@gmail.com",
            "first_name": "Johanncio",
            "last_name": "Granadancio",
            "relay_state": "123",
            "tags_values": "EL Certified,SC CWD General,SC CLD Certified,Cycle 3 2017,Cycle 2 2017,CORE Program,Pre MOD II Email,Pre MOD I Email,Post MOD III Access,Post MOD II Email,Post MOD II Access,Post Mod I Access"
        };

        body = JSON.stringify(body);
        console.log('ssoELIShopy: ' + body);

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

}

export class UpdateRaterDto {
    assignmentId: number;
    raterId: number;
    firstName: string;
    lastName: string;
    relationship: number;
}

export class ImportRatersDto {
    clientId: number;
    assignedBy: number;
    assignmentId: number;
    data: string;
    expiresIn: number;
    scheduledFor: string;
    language: string;
    sendEmailInvitationNow: boolean;
    timeOffSet: number;
}

export class AssessmentAssignmentDto {
    CoachId?: number;
    AssessmentId: number;
    Language: string;
    ScheduledDate: string;
    ScheduledTime: string;
    TimeOffset: number;
    ExpiresIn: string;
    SendNow: boolean;
    ClientIds: number[];
    UseCustomEmailTemplates: boolean;
    EmailTemplates: any[];
    Tags: string[];
    Raters: any[];
    MetaData: any[];
}

export class UserInfoDto {
    FirstName: string;
    LastName: string;
    BusinessName: string;
    Email: string;
    Logo: string;
}

export class CoachClientDto {
    ClientId: number;
    FirstName: string;
    LastName: string;
    Email: string;
}